// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__1VuVq","heading_color":"Heading_heading_color__82Tt9","heading_title":"Heading_heading_title__+V5kN"};